import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const HeartStateTrueIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "HeartStateTrueIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M19.7681 21.5H16.092C14.8594 21.5 13.8601 20.5139 13.8601 19.2975V15.7673C13.8601 15.4936 13.6353 15.2718 13.358 15.2718H10.6409C10.3636 15.2718 10.1388 15.4936 10.1388 15.7673V19.2975C10.1388 20.5139 9.13951 21.5 7.90686 21.5H4.23192C2.99927 21.5 2 20.5139 2 19.2975V9.85132C2 9.11865 2.3697 8.43407 2.98602 8.02554L10.7556 2.87536L10.7561 2.87439C11.5131 2.37504 12.4893 2.37504 13.2444 2.87536L21.0129 8.02485C21.6299 8.43383 22 9.11912 22 9.85258V19.2975C22 20.5139 21.0007 21.5 19.7681 21.5Z"
        fill="url(#paint0_linear_23_9488)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_23_9488"
          x1="2"
          y1="13.7554"
          x2="22"
          y2="13.7554"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DD3422" />
          <stop offset="1" stopColor="#FC3B26" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default HeartStateTrueIcon;
